import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Format, Lock } from 'src/Components'

const defaultProps = {
  locked: false
}

const propTypes = {
  annualEarnings: PropTypes.number,
  locked: PropTypes.bool,
  monthlyEarnings: PropTypes.number
}

const FactTable = ({ annualEarnings, locked, monthlyEarnings }) => (
  <div className='fact-set fact-set--vertical fact-set--vertical--alternate-colors'>
    <div className='fact'>
      <div className='explanation'>
        <h3>
          <FormattedMessage
            id='AirDna.summary.avgMonthlyRevenue'
            defaultMessage='Avg. Monthly Revenue'
          />
        </h3>
      </div>

      <Lock enabled={locked}>
        <div className='value'>
          <span className='number text-positive'>
            <Format.Currency value={Math.round(monthlyEarnings)} />
          </span>
        </div>
      </Lock>
    </div>
    <div className='fact'>
      <div className='explanation'>
        <h3>
          <FormattedMessage
            id='AirDna.summary.annualRevenue'
            defaultMessage='Annual Revenue'
          />
        </h3>
      </div>
      <Lock enabled={locked}>
        <div className='value'>
          <span className='number text-positive'>
            <Format.Currency value={Math.round(annualEarnings)} />
          </span>
        </div>
      </Lock>
    </div>
  </div>
)

FactTable.defaultProps = defaultProps
FactTable.propTypes = propTypes

export default FactTable
